// JavaScript code for sn/header component
(($) => {

    "use strict";
    console.log("sn/header scripts loaded...");

    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 100) {
            $(".sn-header").addClass("expanded");
        } else {
            $(".sn-header").removeClass("expanded");
        }
    });
    $(window).trigger("scroll");

    $(".btn-search-desktop").on("click", function() {
        $(".search-overlay input#filterInput").val('all');
       $(".search-overlay").addClass("active");
    });
    $(".search-overlay .btn-close").on("click", function() {
         $(".search-overlay").removeClass("active");
    });

})(jQuery);